export default function hpAlphanumericOnly() {
    return {
        require: 'ngModel',
        restrict: 'A',
        link(scope, element, attr, ngModelCtrl) {
            function validateEntry(text) {
                const filteredEntry = text.replace(/[^0-9A-Za-z ,/\-#]/g, '');
                if (filteredEntry !== text) {
                    ngModelCtrl.$setViewValue(filteredEntry);
                    ngModelCtrl.$render();
                }
                return filteredEntry;
            }

            ngModelCtrl.$parsers.push(validateEntry);
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/directives/hpAlphanumericOnly.directive.js